"use strict";
/*jshint esversion: 11 */
import React, {useEffect, useRef} from 'react';
import PropTypes from "prop-types";
import Modal from 'bootstrap/js/dist/modal';

export default function CsfMembreReportUfcModal({handleContinue, setModalInstance}) {
  const reportModalRef = useRef();

  useEffect(() => {
    setModalInstance(new Modal(reportModalRef.current));
  }, []);

  return (
    <div ref={reportModalRef} className="modal fade" id="memberReportModal" tabIndex="-1" role="dialog"
      aria-labelledby="memberReportModalTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="memberReportModalTitle">{window.Drupal.t('member.reportufc.modal.title')}</h2>
            <button type="button" className="close" data-dismiss="modal"
              aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span
                className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="d-flex align-items-center mt-3 px-3">
              <span className="flex-shrink-0 mr-2">
                <i className="icon icon-member-exclamation bg-primary"><span className="d-none">&nbsp;</span></i>
              </span>
              <p className="mb-0" dangerouslySetInnerHTML={{ __html: window.Drupal.t('member.reportufc.modal.text')}}></p>
            </div>
          </div>

          <div className="modal-footer">
            <div className="space-between-wrapper">
              <button type="button"
                className='button btn-outlined btn-larger'
                data-dismiss="modal" >
                {window.Drupal.t('fournisseur.back.btn')}
              </button>
              <button type="button"
                className='button btn-larger btn-pale'
                onClick={handleContinue}
              >
                {window.Drupal.t('fournisseur.recognition.before-beginning-modal.continue.btn')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CsfMembreReportUfcModal.propTypes = {
  handleContinue: PropTypes.func,
  setModalInstance: PropTypes.func
};
